import { useQuery } from "@tanstack/react-query";
import apiSubscription from "../../services/subscription";

/**
 * Subscription plan-related hooks.
 *
 * - useProjectPlans({ id_project }) — list of plans for a project
 * - useTerms()                       — billing term options (Monthly/Yearly)
 *
 * Both relate to plan selection, but have different lifecycles:
 *  - Plans depend on project + can change as new packages roll out (5min cache)
 *  - Terms are global + rarely change (1hr cache)
 */

/**
 * Fetches the full list of subscription plans available for a project.
 * Used by PlanCarousel in AccountStep.
 */
export function useProjectPlans({ id_project } = {}) {
  return useQuery({
    queryKey: ["subscription", "project_plans", id_project],
    queryFn: () => apiSubscription.getProjectPlans({ id_project }),
    enabled: !!id_project,
    staleTime: 1000 * 60 * 5,
  });
}

/**
 * Billing term options (Monthly / Yearly).
 * Used by AccountStep to show the term toggle when plan supports both.
 *
 * Returns: [
 *   { value: "MONTHLY", label: "รายเดือน", months: 1 },
 *   { value: "YEARLY",  label: "รายปี",    months: 12 }
 * ]
 */
export function useTerms() {
  return useQuery({
    queryKey: ["subscription", "terms"],
    queryFn: () => apiSubscription.getTerms(),
    staleTime: 1000 * 60 * 60,   // 1 hour — terms rarely change
  });
}